<script>
  import { Chart, registerables } from "chart.js";
  import "chartjs-adapter-moment";
  Chart.register(...registerables);
  import { onMount, afterUpdate } from "svelte";

  //export let label = "";
  export let width = 400;
  export let height = 400;
  export let data = [];
  //export let highlight = "";
  export let isMacro = false;

  let plotCanvas;
  let myChart;
  let initialized = false;

  afterUpdate(() => {
    if (initialized) {
      let style = getComputedStyle(document.body);
      let primCol = style.getPropertyValue("--cds-text-01");
      myChart.options.scales.x.ticks.color = primCol;
      myChart.options.scales.y.ticks.color = primCol;
      Chart.defaults.color = primCol;
      primCol = style.getPropertyValue("--cds-text-03");
      myChart.options.scales.x.grid.color = primCol;
      myChart.options.scales.y.grid.color = primCol;
      console.log(data);
      myChart.data.datasets = data;

      myChart.update();
      console.log(myChart.data.datasets[0]);
    }
  });

  onMount(() => {
    var ctx = plotCanvas.getContext("2d");
    myChart = new Chart(ctx, {
      type: "scatter",
      data: {
        datasets: data,
      },
      options: {
        elements: {
          point: {
            radius: 2,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: "case number",
              font: {
                size: 14,
              },
              padding: {
                top: 10,
                bottom: 20,
              },
            },
          },
          x: {
            type: "timeseries",
            time: {
              unit: "day",
              displayFormats: {
                day: "MMM DD",
              },
            },
            ticks: {
              source: "data",
              autoSkip: true,
              maxTicksLimit: 10,
              maxRotation: 45,
              minRotation: 45,
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    });

    initialized = true;
  });

  // $:{
  //     if(initialized && typeof highlight === 'string' && Object.keys(data).indexOf(highlight) >= 0){
  //         myChart.data.datasets[0].backgroundColor = [...backgroundColor];
  //         myChart.data.datasets[0].backgroundColor[Object.keys(data).indexOf(highlight)] = "rgba(00, 176, 240, 1)";
  //         myChart.update();
  //     }

  // }
</script>

{#if isMacro}
  <canvas bind:this={plotCanvas} width="400" height="400"></canvas>
{:else}
  <div style="width:{width}; height:{height}; display:inline-block;">
    <canvas bind:this={plotCanvas} width="400" height="400"></canvas>
  </div>
{/if}
